import React from 'react';
import { STATUS_ICON, STATUS_LABEL } from '../constants';
import { IStepperProps } from '../types';

const Stepper: React.FC<IStepperProps> = ({ steps, activeStepId, onSelectStep }) => (
	<div className="np-stepper">
		{steps.map(step => (
			<div
				key={step.id}
				className={`np-step ${step.status}`}
				onClick={() => onSelectStep(step.id)}
				style={{ cursor: step.status !== 'blocked' ? 'pointer' : 'default' }}
				title={step.status === 'blocked' ? 'Complete the Custom Domain step first' : step.label}
			>
				<div
					className="np-step-circle"
					style={{
						outline: activeStepId === step.id ? '3px solid #0056b3' : 'none',
						outlineOffset: '2px',
					}}
				>
					<i className={STATUS_ICON[step.status]}></i>
				</div>
				<div className="np-step-label">
					<strong>{step.label}</strong>
					<span className={`np-status-badge ${step.status}`}>
						{STATUS_LABEL[step.status]}
					</span>
					<br />
					<span>{step.sublabel}</span>
				</div>
			</div>
		))}
	</div>
);

export default Stepper;
